import React from "react";
import Layout from "../../layouts/Layout";
import { Calendar, Badge, Select, Row, Col, Button } from "antd";
import _ from "lodash";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import ScheduleBook from "./ScheduleBook";
import { useNavigate, useSearchParams } from "react-router-dom";
import HeaderCalendar from "../../components/general/HeaderCalendar";
import apiService from '../../utils/api.service';
import moment from "moment";
import Lineliff from '../../components/LineLiff';
import { connect } from "react-redux";
import actions from "../../redux/actions";
import BookCircle from "../../components/general/BookCircle"
import helper from "../../utils/helper"
import BButton from "../../components/general/BButton"

moment.updateLocale("en", {
  weekdaysMin: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  // months:['January(TH)', 'February(TH)', 'March(TH)', 'April(TH)', 'May(TH)', 'June(TH)', 'July(TH)', 'August(TH)', 'September(TH)', 'October(TH)', 'November(TH)', 'December(TH)']
});

function getMonthData(value) {
  if (value.month() === 8) {
    return 1394;
  }
}

function monthCellRender(value) {
  const num = getMonthData(value);
  return num ? (
    <div className="notes-month">
      <section>{num}</section>
      <span>Backlog number</span>
    </div>
  ) : null;
}

const calendar_data_def = [
  { date: moment().add("d", -1), type: "error" },
  { date: moment().add("d", -1), type: "error" },
  { date: moment().add("d", -1), type: "error" },
  { date: moment(), type: "error" },
  { date: moment().add("d", 1), type: "warning" },
  { date: moment().add("d", 5), type: "warning" },
  { date: moment().add("d", 10), type: "warning" },
  { date: moment().add("d", 7), type: "success" },
  { date: moment().add("d", 3), type: "success" },
]

const dateEventdef = {
  date: moment(),
  status: "รออนุมัติ",
  scheduleList: [
    {
      locationName: "โรงพยาบาล Prince : วอร์ด ICU",
      shift: "กะเช้า : 07.00 - 19.00 น.",
    }
  ]
}
class MySchedule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      memberId: null,
      calendar_data: [],
      currentDate: moment(),
      dateEvent: {
        date: moment(),
        status: "รออนุมัติ",
        scheduleList: []
      },
    };
    this.onPanelChange = this.onPanelChange.bind(this);
    this.dateCellRender = this.dateCellRender.bind(this);
    this.selectShift = this.selectShift.bind(this);
    // this.cbLineLiff = this.cbLineLiff.bind(this)
    console.log("moment", moment().format("DD-MMMM-YYYY"));
  }

  componentDidMount() {
    // this.SearchMySchedule()
    const payload = { memberId: this.props?.user?.lineId?.memberId, month: moment(this.state.currentDate).format('MM'), year: moment(this.state.currentDate).format('YYYY') }
    this.setState({ memberId: this.props?.user?.lineId?.memberId },() => { this.SearchMySchedule(payload) })
  }
  // cbLineLiff (e) {
  //   const payload = { memberId: e.memberId, month: moment(this.state.currentDate).format('MM'), year: moment(this.state.currentDate).format('YYYY') }
  //   this.setState({ memberId: e.memberId },() => { this.SearchMySchedule(payload) })
  // }

  async SearchMySchedule(payload = {}) {
    try {
      // const payload = { memberId: this.props?.user?.lineId?.memberId }
      const header = helper.GEN.toValueHeader(this.props)
      const { resData } = await apiService.BookShift.SearchMySchedule(payload, header)
      if (resData.resultCode === "20000") {
        // let { calendar_data } = this.state
        console.log('resData >>', resData.data)
        const FORMAT = "YYYY-MM-DD";
        let tmp = []
        let mapDateEvents = {}
        for (const rd of resData.data) {
          for (let ws of rd.workShiftSchedule) {
            const dateStr = moment(ws.date).format(FORMAT)
            if (mapDateEvents[dateStr] && Array.isArray(mapDateEvents[dateStr])) {
              console.log('rd >>', rd)
              ws.statusmain = rd.status
              mapDateEvents[dateStr].push(ws)
            } else {
              ws.statusmain = rd.status
              mapDateEvents[dateStr] = [ws]
              tmp.push({ date: moment(ws.date) , type: "warning", dateStr: dateStr })
            }
          }
        }
        console.log('tmp >>', tmp)
        console.log('mapDateEvents >>', mapDateEvents)
        tmp = tmp.map( item => ({ ...item, dateEvents: mapDateEvents[item.dateStr] }))
        console.log('tmp ANS >>', tmp)
        this.setState({ calendar_data: tmp }, ()=> {
          const { currentDate } = this.state
          this.selectDateEvent(currentDate)
        })
      }
    }
    catch(e){
      console.log('API ERR', e)
    }
  }


  onPanelChange(value, mode) {
    this.setState({ currentDate: value }, () => {
      const { memberId } = this.state
      const payload = { memberId: memberId, month: moment(this.state.currentDate).format('MM'), year: moment(this.state.currentDate).format('YYYY') }
      this.SearchMySchedule(payload)
    });
  }

  getListData(value) {
    let listData;
    let temp = _.find(
      this.state.calendar_data,
      (r) => r.date.format("DD-MM-YYYY") === value.format("DD-MM-YYYY")
    );
    let date = this.state.currentDate;
    let month = date.month() + 1;
    if (temp && value.month() + 1 === month) {
      listData = [{ type: temp.type, content: "" }];
    }
    return listData || [];
  }

  dateCellRender(value) {
    const listData = this.getListData(value);
    return (
      <>
        {listData.map((item, index) => (
          <BookCircle key={index} status={item.type}/>
        ))}
      </>
    );
  }
  selectDateEvent(date) {
    let { calendar_data, dateEvent } = this.state;
    const FORMAT = "YYYY-MM-DD";
    console.log("selectDateEvent calendar_data >>", calendar_data);
    console.log("selectDateEvent >>", moment(date).format(FORMAT));
    console.log("selectDateEvent date >>", moment(date).format(FORMAT));
    const findEvent = calendar_data.find(
      (item) => item.dateStr === moment(date).format(FORMAT)
    );
    console.log("selectDateEvent findEvent >>", findEvent);
    console.log("selectDateEvent --------------------------- ");
    if (findEvent) {
      dateEvent = {
        date: date,
        status: "error",
        scheduleList: findEvent.dateEvents
      };
    } else {
      dateEvent = {
        date: date,
        status: 'no-event',
        scheduleList: []
      };
    }
    this.setState({ dateEvent });
  }
  selectShift() {
    this.props.navigate(`/schedule-step2`);
  }

  render() {
    let { dateEvent, calendar_data } = this.state;
    return (
      <Layout>
        <div className="container-schedule">
          <div className="header">
            <div className="main-header-text">ตารางเวรของฉัน</div>
          </div>
          <div className="calendar-group">
            <div className="main-calendar">
              <Calendar
                value={this.state.currentDate}
                onSelect={(e) => {
                  console.log("onSelect", e);
                }}
                onChange={(e) => {
                  this.setState({ currentDate: e }, () => {
                    if (e && e.isValid()) {
                      console.log(e);
                      this.selectDateEvent(e);
                    }
                  });
                }}
                dateCellRender={this.dateCellRender}
                monthCellRender={monthCellRender}
                fullscreen={false}
                headerRender={({ value, type, onChange, onTypeChange }) => {
                  return <HeaderCalendar value={value} onChange={onChange} />
                }}
                onPanelChange={this.onPanelChange}
              />
            </div>
            <div className="border-80"></div>
            <ScheduleBook
              date={dateEvent.date} 
              status={dateEvent.status}
              scheduleList={dateEvent.scheduleList}
            />
            
      
          </div>
          <div className="s-book-footer" style={{ marginBottom: '4px' }}>
              <BButton setStyle="block" onClick={this.selectShift}>จองตารางเวร</BButton>
            </div>
        </div>
      </Layout>
    );
  }
}


function MyScheduleRoute(props) {
  let navigate = useNavigate();
  const [searchParams] = useSearchParams();
  return <MySchedule navigate={navigate} searchParams={searchParams} {...props}/>
}

const mapStateToProps = (state) => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps, actions)(MyScheduleRoute);